import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitQuanrantineReasonServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitQuanrantineReasonServices";

const AddNewStudyKitQuanrantineReason = ({ getEIWRSKitQuanrantineReasonData }) => {
  let { studyId } = useParams();
  const [reason, setReason] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewEIWRSKitQuanrantineReason = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.reason = reason;
    let data = await eiwrsKitQuanrantineReasonServices.addNewEIWRSKitQuanrantineReason(
      userData
    );
    if (data?.statusCode === 200) {
      setReason("");
      getEIWRSKitQuanrantineReasonData()
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    setReason("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Reason{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setReason(e.target.value)}
          value={reason}
          className="br3"
          placeholder="Enter Reason"
          type="text"
        />
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!reason || buttonLoader}
          onClick={addNewEIWRSKitQuanrantineReason}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add Reason"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyKitQuanrantineReason;
